

















































































































































import { defineComponent, ref, watch, computed } from '@vue/composition-api';
import store from '@/store';

import { DatasetListing } from '@/types';
import { actions } from '@/controller';
import { browseDatasetMenu } from '../state';
import { useClient, useDatasets } from '@/use';

const adminCheck = computed(() => store.getters.isAdmin);

const headers = [
  { text: 'Dataset ID', value: '_id' },
  { text: 'Study Type', value: 'study_type', sortable: false },
  { text: 'Race', value: 'subject_race', sortable: false },
  { text: 'Time Created', value: 'created_at' },
  { text: 'No. Samples', value: 'count' },
  { text: 'Flagged Frames', value: 'flagged' },
  { text: 'Validation Only', value: 'validation_only', sortable: false },
  { text: adminCheck.value ? 'Delete' : '', value: 'actions', sortable: false },
];

export default defineComponent({
  name: 'BrowseDatasetMenu',
  setup() {
    const {
      loading,
      items,
      selected,
      fetch,
      dataTableInfo,
      datasetTableOptions,
      itemsPerPage,
      search,
      filterStudyType,
      filterSubjectRace,
      filterValidationOnly,
      onlyShowFlagged,
    } = useDatasets();

    const client = useClient();
    const subjectTypes = computed(() => store.state.application.applicationData?.lists.subject_races.map((st) => st.toUpperCase()));
    const studyTypes = computed(() => store.state.application.applicationData?.lists.study_types);
    const validationOnlys = [true, false];

    const closeDialog = () => { browseDatasetMenu.value = false; };
    const deleteDialogActive = ref(false);

    const selectedDataset = ref<DatasetListing | null>(null);

    function openDeleteDialog(item: DatasetListing) {
      selectedDataset.value = item;
      deleteDialogActive.value = true;
    }

    function closeDeleteDialog() {
      selectedDataset.value = null;
      deleteDialogActive.value = false;
    }

    async function loadRemoteDataset(dataset: DatasetListing) {
      closeDialog();
      // eslint-disable-next-line no-underscore-dangle
      actions.fetchDataset(dataset._id, false);
    }

    async function deleteSelectedDataset() {
      const dataset = selectedDataset.value;
      if (dataset === null) {
        return;
      }

      // Set loading to true before request, since the request can take a long time
      loading.value = true;

      // Delete dataset
      await client?.deleteRemoteDataset(dataset);
      closeDeleteDialog();

      // eslint-disable-next-line no-underscore-dangle
      if (store.state.dataset.datasetId === dataset._id) {
        actions.clearDataset();
      }
      selectedDataset.value = null;
      fetch();
    }

    // Fetch Datasets
    watch(browseDatasetMenu, (val) => {
      if (!val) { return; }

      // Fetch datasets
      fetch();
    });

    return {
      headers,
      studyTypes,
      subjectTypes,
      validationOnlys,
      loading,
      search,
      filterStudyType,
      filterSubjectRace,
      filterValidationOnly,
      onlyShowFlagged,
      items,
      browseDatasetMenu,
      selected,
      closeDialog,
      loadRemoteDataset,
      dataTableInfo,
      datasetTableOptions,
      itemsPerPage,
      openDeleteDialog,
      deleteDialogActive,
      selectedDataset,
      closeDeleteDialog,
      deleteSelectedDataset,
      adminCheck,
    };
  },
});
